import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from '../actions/adviserProfiles'

export default function (state = [], action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case events.fetched.publishedProfile:
      var newProfile = action.payload
      newProfile.loading = false
      newState = removeProfile(action.payload.adviserId, state)
      newState = newState.concat([newProfile])
      return newState
    case events.fetching.publishedProfile:
      newState = removeProfile(action.adviserId, state)
      return newState.concat([{
        loading: true,
        adviserId: action.adviserId
      }])
  }
  return state
}

function removeProfile (adviserId, profiles) {
  return profiles.filter((profile) => {
    return profile.adviserId !== adviserId
  })
}
